import store from "../../../Store";
import { toggleURLQuery } from "../../../helpers/UrlHelper";
import getUsers from "../../../ajax/actions/user/users_get";

export function toggleUserListFilter(e) {
  return function (dispatch) {
    let { name, value } = e.target;
    dispatch({ type: "TOGGLE-USER-LIST-FILTER", name, value });
    store.dispatch(getUsers(true));
  };
}

export function setDefaultUserFiltersToURL(history) {
  return (dispatch, getState) => {
    let { data } = getState().siteList;
    let { params } = data;
    Object.keys(params).map((key) => {
      if (
        params[key] !== `` &&
        params[key] !== null &&
        params[key] !== undefined
      ) {
        toggleURLQuery(key, params[key], history);
      }
    });
  };
}

export function resetUsersParams() {
  return (dispatch) => {
    dispatch({ type: "TOGGLE-RESET-USERS" });
  };
}
